import axios from 'axios'
import qs from 'qs'

axios.defaults.withCredentials = false
//axios.defaults.baseURL = window.ServerUrl
//axios.defaults.baseURL = window.ServerUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers['token']= '1231238';

//添加一个请求拦截器
// axios.interceptors.request.use(function (config) {
//   let token = window.sessionStorage.getItem('token');
//   config.headers['token'] = token;
//   return config;
// }, function (error) {
//   // Do something with request error
//   console.info("error: ");
//   console.info(error);
//   return Promise.reject(error);
// });

// 添加一个响应拦截器
// axios.interceptors.response.use(function (response) {
//   if (response.data && response.data.code) {
//     // if (parseInt(response.data.code) === 108 || parseInt(response.data.code) === 109 || response.data.msg === 'TOKEN失效，请重新登录' || response.data.msg === 'TOKEN不存在') {
//     //   //未登录
//     //   response.data.msg = "登录信息已失效，请重新登录";
//     //   alert(response.data.msg);
//     //   // routerIndex.push('/login');
//     // }
//     // if (parseInt(response.data.code) === -1) {
//     //   alert("请求失败");
//     // }
//   }
//   return response;
// }, function (error) {
//   // Do something with response error
//   console.dir(error);
//   // alert("服务器连接失败");
//   return Promise.reject(error);
// })


export default {
	/**
	 * get方法，对应get请求
	 * @param {String} url [请求的url地址]
	 * @param {Object} params [请求时携带的参数]
	 */
	get(url, params) {
		// let token = window.sessionStorage.getItem('token');
		return new Promise((resolve, reject) => {
			axios.get(url, {
				params: params,
				// headers: {
				// 	token: token
				// }
			}).then(res => {
				console.log(res)
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},
	/**
	 * post方法，对应post请求
	 * @param {String} url [请求的url地址]
	 * @param {Object} params [请求时携带的参数]
	 */
	post(url, params = {}) {
		params.channel = 'APP'
		params.access_token = localStorage.getItem('token')
		params.operator = 1000
		if (url == 'SendSms' || url == 'CheckSmsLogin' || url == 'Login') {
			params.operator = 99
			delete params.access_token
			url = window.loginUrl + url
		}
		return new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				headers: { 'content-type': 'application/x-www-form-urlencoded' },
				data: qs.stringify(params),   // 用 qs 将js对象转换为字符串 'name=edward&age=25'
				url: url
			}).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},
	/**
	 * postFormData方法，对应post请求，用来提交文件+数据
	 * @param {String} url [请求的url地址]
	 * @param {Object} params [请求时携带的参数]
	 */
	postFormData(url, params) {
		return new Promise((resolve, reject) => {
			axios({
				headers: {
					'Content-Type': 'multipart/form-data' // ;boundary=----WebKitFormBoundaryQ6d2Qh69dv9wad2u
				},
				transformRequest: [function(data) { // 在请求之前对data传参进行格式转换
					const formData = new FormData()
					Object.keys(data).forEach(key => {
						formData.append(key, data[key])
					})
					return formData
				}],
				url,
				method: 'post',
				data: params
			}).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	}
}
